import { render, staticRenderFns } from "./SubmissionForComplianceReviews.vue?vue&type=template&id=6e58c2fe&scoped=true"
import script from "./SubmissionForComplianceReviews.vue?vue&type=script&lang=js"
export * from "./SubmissionForComplianceReviews.vue?vue&type=script&lang=js"
import style0 from "./SubmissionForComplianceReviews.vue?vue&type=style&index=0&id=6e58c2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58c2fe",
  null
  
)

export default component.exports